import { redirect } from '@modern-js/runtime/router';
import { getSystem } from '@/utils';
import { getMeetingEnvByHostname } from '@/utils/meetingEnv';

export const loader = async () => {
  const systemInfo = getSystem();
  const isPc = systemInfo === 'pc';
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const env = getMeetingEnvByHostname(hostname);
  const rootUrlMap = {
    development: 'https://meeting-mobile.hkgai.net',
    test: 'https://meeting-mobile-test.hkgai.org',
    production: 'https://meeting-mobile.hkgai.org',
  };
  const rootPath = isPc ? '/notebook' : `${rootUrlMap[env]}/h5`;

  return redirect(rootPath);
};
